import React from "react";
import { NavLink } from "react-router-dom";
import { css, useTheme } from "@emotion/react";

import { AUTH_LOGIN_URL } from "core/includes/pricingAuthRedirects";
import RoundTextButton from "core/Components/Buttons/RoundTextButton";
import { HOME_USER_URL } from "core/config/config";

type Props = {
    closeMenuHandler: Function,
    menuButton?: Button
    hideCustomButton?: boolean,
    buttonFontSize?: number,
};

const BurgerNavLinkButtons: React.FC<Props> = ({
    closeMenuHandler,
    menuButton = undefined,
    hideCustomButton = false,
    buttonFontSize = 18,
}) => {
    const theme = useTheme();
    const buttonWidth = 167, buttonHeight = 48;
    const linkURL = menuButton?.innerURL || menuButton?.outerURL;

    const closeHandler = () => {
        closeMenuHandler();
    };

    const style = css`
        display: flex;
        flex-direction: column;

        a:last-child {
            margin-top: 12px;
        }
    `;

    return (
        <div css={style}>
            {(!hideCustomButton && menuButton?.buttonText && linkURL) && (
                <NavLink to={linkURL}>
                    <RoundTextButton
                        minWidth={buttonWidth}
                        height={buttonHeight}
                        fontSize={buttonFontSize}
                        textColour={"black"}
                        backgroundColour={theme.colours.gold}
                        backgroundHoverColour={theme.colours.mySin}
                        onClick={closeHandler}
                    >
                        {menuButton.buttonText}
                    </RoundTextButton>
                </NavLink>
            )}
            <NavLink key={"/login"} to={`${HOME_USER_URL}${AUTH_LOGIN_URL}`}>
                <RoundTextButton
                    onClick={closeHandler}
                    width={buttonWidth}
                    height={buttonHeight}
                    fontSize={buttonFontSize}
                    textColour={"black"}
                    textHoverColour={theme.colours.curiousBlue}
                    backgroundColour={"white"}
                    backgroundHoverColour={"white"}
                    noButtonBorderHover
                >
                    Log in
                </RoundTextButton>
            </NavLink>
        </div>
    );
};

export default BurgerNavLinkButtons;